module.exports = __webpack_public_path__ + "static/media/menu.819119b8.svg";